/**
 * Union型のSwitch文でcaseが網羅されていない場合にエラーを返す関数
 * @param x - type
 */
export const assertNever = (x: never): never => {
  throw new Error('Unexpected object: ' + x);
};
